//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import LazyTextarea from '@/components/form/lazy_textarea'
import check from '@/common/utils/check'
export default {
    data () {
        return {
            content: '',
            sending: false,
            bottom: 0
        }
    },
    watch: {
        show () {
            this.content = ''
            this.sending = false
        }
    },
    computed: {
        placeholder () {
            const nickname = this.reply_user && this.reply_user.nickname ? this.reply_user.nickname : this.reply_item.nickname
            if (nickname) {
                return `回复@${nickname}`
            }
            return '我要说两句'
        }
    },
    methods: {
        onBlur () {
            this.bottom = 0
        },
        changeBottom (bottom) {
            console.error(bottom)
            this.bottom = `${bottom}px`
        },
        async submitComment () {
            const content = this.content.trim()
            if (this.sending) {
                return
            }
            this.sending = true
            const reply_comment_id = this.reply_user && this.reply_user.id ? this.reply_user.id : this.reply_item.id
            if (content === '') {
                this.sending = false
                this.$wx.showToast({
                    title: '您还未填写评论内容',
                    icon: 'none'
                })
                return
            }
            this.submit(content, reply_comment_id)
        },
        submit (content, reply_comment_id) {
            const { building_id } = this.$route.query
            const params = {
                content
            }
            if (reply_comment_id) {
                params.parent_comment_id = reply_comment_id
            }
            console.log(params)
            Service.postBuildingComment(building_id, params).then((data) => {
                this.sending = false
                if (!data) {
                    return
                }
                this.$emit('changeComments', data, this.reply_item.id)
            }).catch(() => {
                this.sending = false
            })
        },
        hide () {
            this.$emit('hide')
        }
    },
    components: {
        LazyTextarea
    },
    props: {
        reply_item: {
            type: Object
        },
        reply_user: {
            type: Object
        },
        show: {
            type: Boolean
        }
    }
}
